

document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('.plate-slider');
  const track = document.querySelector('.plate-slider__track');
  const progress = document.querySelector('.plate-progress__bar');

  const nextBtn = document.querySelector('.plate-btn');
  const btnIcon = nextBtn?.querySelector('.plate-btn__icon');
 const cards = track.querySelectorAll('.plate-card');

  if (nextBtn && cards.length) {
    let direction = 1; 

    const getCardWidth = () => {
      const card = cards[0];
      const styles = getComputedStyle(card);
      return card.offsetWidth + parseInt(styles.marginRight || 0);
    };

    nextBtn.addEventListener('click', () => {
      const cardWidth = getCardWidth();
      const maxScroll = track.scrollWidth - slider.clientWidth;
      const tolerance = 5;

      let currentScroll = slider.scrollLeft;
      let nextScroll = currentScroll + direction * cardWidth;

      
      if (currentScroll >= maxScroll - tolerance) {
        direction = -1;
        nextBtn.classList.add('is-reverse');
        nextScroll = currentScroll - cardWidth;
      }

      
      if (currentScroll <= tolerance) {
        direction = 1;
        nextBtn.classList.remove('is-reverse');
        nextScroll = currentScroll + cardWidth;
      }

      slider.scrollTo({
        left: Math.max(0, Math.min(nextScroll, maxScroll)),
        behavior: 'smooth'
      });
    });
  }

  if (!slider || !track || !progress) return;

  const isDesktop = window.matchMedia('(pointer: fine)').matches;

  // DRAG 
  if (isDesktop) {
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('is-dragging');
      startX = e.pageX;
      scrollLeft = slider.scrollLeft;
    });

    window.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('is-dragging');
    });

    window.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const walk = e.pageX - startX;
      slider.scrollLeft = scrollLeft - walk;
    });
  }

  // PROGRESS BAR
  slider.addEventListener('scroll', () => {
    
    const tolerance = 5;

    slider.addEventListener('scroll', () => {
      const maxScroll = track.scrollWidth - slider.clientWidth;
      const currentScroll = slider.scrollLeft;

      // Progress bar
      const percent = Math.max(10, (currentScroll / maxScroll) * 100);
      progress.style.width = `${percent}%`;

      
      if (currentScroll >= maxScroll - tolerance) {
        direction = -1;
        nextBtn.classList.add('is-reverse');
      }

      
      if (currentScroll <= tolerance) {
        direction = 1;
        nextBtn.classList.remove('is-reverse');
      }
    });

  });

  slider.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') {
      nextBtn.click();
    }

    if (e.key === 'ArrowLeft') {
      direction = -1;
      nextBtn.click();
    }
  });

});
